<div class="preview-container" *ngIf="preview">
    <div class="close-icon" *ngIf="device?.isDesktop">
        <i class="icon-smash_close icon-close-preview" (click)="closePreview()"></i>
    </div>
    <div class="deck-container" [ngClass]="{'desktop': device?.isDesktop, 'mobile': device?.isMobile, 'tablet': device?.isTablet}">
        <app-deck [preview]="preview" [files]="files" [selectedFiles]="selectedFiles" [device]="device" (unscroll)="unscroll($event)">
        </app-deck>
    </div>
    <div class="download-all-mobile" *ngIf="device?.isMobile && preview?.transfer?.filesNumber > 1">
        <button class="red-link" (click)="downloadZip()">{{ 'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL' | translate }}</button>
        <div class="help">
            {{ 'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL_HELP' | translate }}

            <!-- ios -->
            <a target="_blank" *ngIf="device?.os === 'iOS'" href="{{ 'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL_IOS_FAQ_LINK' | translate }}">{{
                'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL_FAQ_LABEL'
                | translate }}</a>
            <!-- android -->
            <a target="_blank" *ngIf="device?.os !== 'iOS'" href="{{ 'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL_ANDROID_FAQ_LINK' | translate }}">{{
                'VIEWER_MOBILE_BUTTON_LABEL_DOWNLOAD_ALL_FAQ_LABEL' | translate }}</a>

        </div>
    </div>
</div>